angular
	.module 'App.Component'
	.component 'notifications',
		{
			templateUrl: '@component/notification/notification.view.html'
			controller: 'NotificationComponent'
			controllerAs: 'notifications'
		}

class NotificationComponent extends AbstractController
	@registerController()
	@inject '$rootScope',
		'$uibModal'
		'$interval'
		'NotificationRepository'
		'UserInformation'
		'localStorageService'
		'MessageTerminal'

	initialize: ->
		@pollTimer = null
		@newNotificationsCount = 0
		@totalNotifications = 0
		@notifications = null
		@isActive = false
		@page =
			size: 5
			page: 1
			total: 1
		@customNotificationData =
			username: @UserInformation.getMasterUser()?.email
			currentVersion: @$rootScope.version

		@fetchNotifications()
		@pollNotifications()

	toggleNotificationsDisplay: ->
		if _.isEmpty(@notifications)
			return

		if @isActive
			@setActive(false)

			return

		@setActive(true)

		@localStorageService.set('notification.last_view', _.first(@notifications).create_time)

	setActive: (state = true) ->
		@isActive = state

		if state == false
			@newNotificationsCount = 0

			for notification in @notifications
				notification.is_new = false

	getLastViewTime: ->
		return @localStorageService.get('notification.last_view') || 0

	calculateNewNotificationsCount: ->
		if @notifications.length == 0
			@newNotificationsCount = 0

			return

		lastView = @getLastViewTime()

		for notification in @notifications
			if notification.create_time > lastView
				notification.is_new = true
				@newNotificationsCount++
			else
				notification.is_new = false

	viewNotification: (notification) ->
		@setActive(false)

		@$uibModal.open
			templateUrl: '@component/notification/modals/notification.modal.view.html'
			size: 'md'
			bindToController: true
			controllerAs: 'notificationViewModal'
			controller: ($uibModalInstance, notification, closeCallback) ->
				$onInit: ->
					@notification = notification
				close: ->
					$uibModalInstance.dismiss('cancel')
					closeCallback()
			resolve:
				notification: => notification
				# Resolve to function
				closeCallback: => =>
					@setActive(true)

	pollNotifications: ->
		@pollTimer = @$interval(
			() => @fetchNotifications(),
			10 * 60 * 1000 # 10 minutes
		)

		@MessageTerminal.on @$rootScope, @MessageTerminal.events.LOGOUT, => @$interval.cancel(@pollTimer)

	fetchNotifications: ->
		if @isActive
			return

		@$rootScope.ignoreLoader = true
		@NotificationRepository
			.getEntities()
			.then (notifications) =>
				if _.isEmpty(@notifications)
					@notifications = notifications
				else
					currentNotifications = _.pluck(@notifications, 'id')

					for notification in notifications
						if currentNotifications.includes(notification.id)
							currentNotification = _.find(@notifications, {id: notification.id})
							currentNotification = _.extend(currentNotification, notification)
						else
							@notifications.push(notification)

				for notification in @notifications
					if !notification.data?
						notification.data = @customNotificationData
					else
						notification.data = _.extend(notification.data, @customNotificationData)

					notification.title = @interpolate(notification.title, notification.data)

					if notification.content?
						notification.content = @interpolate(notification.content, notification.data)

				@totalNotifications = notifications.length
				@page.total = Math.ceil(@totalNotifications / @page.size)

				@notifications.sort((a, b) => parseInt(b.create_time) - parseInt(a.create_time))
				@calculateNewNotificationsCount()
				@setVisibleNotifications()
			.finally =>
				@$rootScope.ignoreLoader = false

	interpolate: (message, data) ->
		for key, value of data
			message = message.replaceAll("{{#{key}}}", value)

		return message

	setVisibleNotifications: ->
		indexFrom = (@page.page * @page.size) - @page.size
		indexTo = indexFrom + @page.size - 1

		for notification, index in @notifications
			notification.is_visible = indexFrom <= index && index <= indexTo

	nextPage: ->
		if @page.page < @page.total
			@page.page++

			@setVisibleNotifications()

	prevPage: ->
		if @page.page > 1
			@page.page--

			@setVisibleNotifications()
